import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../styles/pages.css';
import { useNavigate } from 'react-router-dom';
import { FaArrowRightLong } from "react-icons/fa6";

const NewsEvents = () => {
    const { id } = useParams(); // Get the news & events ID from the URL
    const [news, setNews] = useState([]);
    const [moreNews, setMoreNews] = useState([]);
    const navigate = useNavigate(); // Initialize useNavigate
    
  
    useEffect(() => {
      axios.get(`https://caritasmathahospital.com/wp-content/themes/my_react_theme/api/news_events.php?id=${id}`)
        .then(response => {
          setNews(response.data);
        })
        .catch(error => {
          console.error("There was an error fetching the news and events!", error);
        });
    }, [id]); 
  
    useEffect(() => {
      // Fetch News & Events
      axios.get('https://caritasmathahospital.com/wp-content/themes/my_react_theme/api/get_latest_news_events.php')
        .then(response => {
          setMoreNews(response.data);
        })
        .catch(error => {
          console.error("There was an error fetching the news and events!", error);
        });
    }, []);

    // Scroll to the top when the id changes (i.e., new news article is loaded)
    useEffect(() => {
      window.scrollTo(0, 0); // Ensure scroll to top happens when the ID changes
    }, [id]); // This effect runs every time the ID changes
    
    const handleNewsClick = (newsId) => {
      navigate(`/news-and-events/${newsId}`); // Use navigate to redirect
      setTimeout(() => {
        document.documentElement.scrollTop = 0;  // For most browsers
        document.body.scrollTop = 0;             // For older browsers / Safari
      }, 0); // Ensure scroll happens after navigation completes
    };

    return (
        <div>
            {moreNews.map(news => (
                <div className="post-row">
                    <span className="post-titles" onClick={() => handleNewsClick(news.id)} >{news.title}</span>
                    <p className='post-link' onClick={() => handleNewsClick(news.id)}> <FaArrowRightLong /> </p>
                </div>
            ))}
        </div>
    );
};

export default NewsEvents;